import React from "react";
import "./Tantam.css";

const items = [
  {
    id: 1,
    title: "An toàn và bảo mật.",
    icon: "/S1.svg",
  },
  {
    id: 2,
    title: "Hỗ trợ tại nhà 24/7 – kể cả tối, cuối tuần",
    icon: "/S2.svg",
  },
  {
    id: 3,
    title: "Chúng tôi đến tận nơi hỗ trợ trong 15-30 phút.",
    icon: "/S3.svg",
  },
];

export default function Tantam() {
  return (
    <section className="simple-credit">
      <div className="simple-credit__container">
        <h2 className="simple-credit__title">Sự tận tâm của chúng tôi</h2>
        <p id="chuthich2">
          Trên thị trường hiện nay có không ít đơn vị cung cấp dịch vụ rút thẻ,
          nhưng thực tế “vàng thau lẫn lộn”. Hàng nghìn khách hàng vẫn chọn dịch
          vụ của chúng tôi vì:{" "}
        </p>
        {/* IMAGE */}

        <div className="simple-credit__list">
          {items.map((item, index) => (
            <div
              className={`simple-credit__item ${
                index !== items.length - 1 ? "has-border" : ""
              }`}
              key={item.id}
            >
              <div className="simple-credit__icon-wrap">
                <img
                  src={item.icon}
                  alt={item.title}
                  className="simple-credit__icon"
                />
              </div>

              <div className="simple-credit__content">
                <p>{item.title}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
